import type { AuthPermissionUser } from '../../services/authPermissions';

// ORDER_STAFF = Handlowiec: full customer master data (decision 2026-09-23).
const CUSTOMER_EDIT_ROLES = ['ADMIN', 'OPERATIONS', 'ORDER_STAFF'];
const CUSTOMER_CREATE_ROLES = ['ADMIN', 'OPERATIONS', 'ORDER_STAFF', 'TESTER'];
const CUSTOMER_DELETE_ROLES = ['ADMIN', 'OPERATIONS', 'ORDER_STAFF'];
const CUSTOMER_LIST_ROLES = ['ADMIN', 'OPERATIONS', 'ORDER_STAFF'];
// Must match backend CUSTOMER_CATEGORY_MANAGEMENT_ROLES in
// backend/src/middleware/customerCategoryAccess.js exactly.
const CUSTOMER_CATEGORY_MANAGEMENT_ROLES = ['ADMIN', 'OPERATIONS', 'ORDER_STAFF'];

export function isCustomerTesterMode(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'TESTER';
}

export function canEditCustomers(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_EDIT_ROLES.includes(user?.role || '');
}

export function canCreateCustomers(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_CREATE_ROLES.includes(user?.role || '');
}

export function canDeleteCustomers(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_DELETE_ROLES.includes(user?.role || '');
}

export function canListCustomers(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_LIST_ROLES.includes(user?.role || '');
}

export function canManageCustomerCategories(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_CATEGORY_MANAGEMENT_ROLES.includes(user?.role || '');
}
